import { useState } from "react";
import CustomDialog from "../../../components/Dialog/DiaCompMedium";
import { Typography, Grid, Tooltip, IconButton, Box, List, ListItem, ListItemText, ListItemIcon } from "@mui/material";
import InfoOutlineIcon from '@mui/icons-material/InfoOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';


export default function DiaGutTest({infotitle, infotext, sx}) {

    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};
  
    return (
      <>
    
   <Box sx={sx}>
        <Tooltip title="Details Microbiome Test" placement="right">
            <IconButton onClick={handleOpen} aria-label="Reschedule" sx={{ '&:hover': {transform: 'scale(1.2)'}, }} >
                <InfoOutlineIcon size="small" sx={{'&:hover': { transform: 'scale(1.4)'}, }}/>
            </IconButton>   
        </Tooltip>
    </Box>
   
    <CustomDialog open={open} onClose={handleClose}

          title="Gut Microbiome Test - ULTIMATE"
         
          content={
  
            <Grid container spacing={2}>
                <Grid item xs={12}>
                <Typography variant="subtitle1" sx={{ my: 2 }}>
                    The Gut Microbiome <strong>"Ultimate"</strong> Test offers the most in-depth analysis 
                    of your microbiome. In addition to all insights of a Standard Microbiome Test, 
                    you’ll also learn how your gut flora is connected to your mental & physical
                    well-being and metabolic health (blood sugar, blood pressure, liver and thyroid function).
                </Typography>

                <List dense>
                    <ListItem disableGutters>
                    <ListItemIcon>
                        <CheckCircleOutlineIcon color="primary" />
                    </ListItemIcon>
                    <ListItemText primaryTypographyProps={{variant: "subtitle1", sx: { lineHeight: 1.6 },}} secondaryTypographyProps={{variant: "subtitle2", sx: { lineHeight: 1.6 },}}
                        primary="Insight into your gut flora"
                        secondary="Understand the key values that determine your gut health"
                    />
                    </ListItem>

                    <ListItem disableGutters>
                    <ListItemIcon>
                        <CheckCircleOutlineIcon color="primary" />
                    </ListItemIcon>
                    <ListItemText primaryTypographyProps={{variant: "subtitle1", sx: { lineHeight: 1.6 },}} secondaryTypographyProps={{variant: "subtitle2", sx: { lineHeight: 1.6 },}}
                        primary="Your bacteria in detail"
                        secondary="Learn which bacterial strains are present in your stool sample"
                    />
                    </ListItem>

                    <ListItem disableGutters>
                    <ListItemIcon>
                        <CheckCircleOutlineIcon color="primary" />
                    </ListItemIcon>
                   <ListItemText primaryTypographyProps={{variant: "subtitle1", sx: { lineHeight: 1.6 },}} secondaryTypographyProps={{variant: "subtitle2", sx: { lineHeight: 1.6 },}}
                        primary="Microbiome and health connection"
                        secondary="How gut bacteria influence immune system, inflammation, skin, and weight"
                    />
                    </ListItem>

                    <ListItem disableGutters>
                    <ListItemIcon>
                        <CheckCircleOutlineIcon color="primary" />
                    </ListItemIcon>
                   <ListItemText primaryTypographyProps={{variant: "subtitle1", sx: { lineHeight: 1.6 },}} secondaryTypographyProps={{variant: "subtitle2", sx: { lineHeight: 1.6 },}}
                        primary="Clues to symptoms"
                        secondary="Does your bacterial profile indicate Leaky Gut, IBS, gluten sensitivity, or SIBO?"
                    />
                    </ListItem>

                    <ListItem disableGutters>
                    <ListItemIcon>
                        <CheckCircleOutlineIcon color="primary" />
                    </ListItemIcon>
                    <ListItemText primaryTypographyProps={{variant: "subtitle1", sx: { lineHeight: 1.6 },}} secondaryTypographyProps={{variant: "subtitle2", sx: { lineHeight: 1.6 },}}
                        primary="Extended recommendations"
                        secondary="Receive recipe suggestions tailored to your microbiome"
                    />
                    </ListItem>

                    <ListItem disableGutters>
                    <ListItemIcon>
                        <CheckCircleOutlineIcon color="primary" />
                    </ListItemIcon>
                   <ListItemText primaryTypographyProps={{variant: "subtitle1", sx: { lineHeight: 1.6 },}} secondaryTypographyProps={{variant: "subtitle2", sx: { lineHeight: 1.6 },}}
                        primary="Physical and mental well-being"
                        secondary="Learn how your microbiome supports mental balance and physical energy"
                    />
                    </ListItem>

                    <ListItem disableGutters>
                    <ListItemIcon>
                        <CheckCircleOutlineIcon color="primary" />
                    </ListItemIcon>
                    <ListItemText primaryTypographyProps={{variant: "subtitle1", sx: { lineHeight: 1.6 },}} secondaryTypographyProps={{variant: "subtitle2", sx: { lineHeight: 1.6 },}}
                        primary="Metabolic health"
                        secondary="How your microbiome affects glucose control, blood pressure, liver function, and thyroid activity"
                    />
                    </ListItem>
                </List>
                </Grid>
            </Grid>
            }
        />
        
</>
)}